import { Injectable } from '@angular/core';
var KtsDateTimeService = /** @class */ (function () {
    function KtsDateTimeService() {
        this.defFormat = {
            format: 'Y/m/d H:i',
            formatDate: 'Y/m/d',
            formatTime: 'H:i'
        };
        this.typeOptions = {
            date: {
                enableTime: false,
                noCalendar: false,
            },
            time: {
                enableTime: true,
                noCalendar: true,
            }
        };
    }
    KtsDateTimeService.prototype.isMobile = function () {
        if (window.navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)) {
            return true;
        }
        return false;
    };
    KtsDateTimeService.prototype.getDefOptions = function (col, msg) {
        col = JSOG.parse(JSON.stringify(col));
        var dayOfWeekStart = msg['au.COMPONENT.KtsDateTimeComponent.option.dayOfWeekStart'] || 'sunday';
        var week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var type = col.controlType;
        var opt = this.typeOptions[type] || {};
        var format = this.getFormatOptions(col, msg);
        var options = {
            formats: format,
            noCalendar: opt['noCalendar'],
            enableTime: opt['enableTime'],
            dateFormat: (type === 'date' ? format.formatDate : (type === 'time' ? format.formatTime : format.format)),
            time_24hr: true,
            locale: {
                weekdays: {
                    shorthand: [
                        msg['au.COMPONENT.KtsDateTimeComponent.label.sunday'] || 'Sun',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.monday'] || 'Mon',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.tuesday'] || 'Tue',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.wednesday'] || 'Wed',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.thursday'] || 'Thu',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.friday'] || 'Fri',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.saturday'] || 'Sat'
                    ]
                },
                months: {
                    longhand: [
                        msg['au.COMPONENT.KtsDateTimeComponent.label.january'] || 'January',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.february'] || 'February',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.march'] || 'March',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.april'] || 'April',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.may'] || 'May',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.june'] || 'June',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.july'] || 'July',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.august'] || 'August',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.september'] || 'September',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.october'] || 'October',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.november'] || 'November',
                        msg['au.COMPONENT.KtsDateTimeComponent.label.december'] || 'December'
                    ]
                },
                firstDayOfWeek: week.indexOf(dayOfWeekStart) >= 0 ? week.indexOf(dayOfWeekStart) : 0,
            }
        };
        var colOptions = jsonpath.value(col, '$..options') || {};
        delete colOptions.format;
        delete colOptions.formatDate;
        delete colOptions.formatTime;
        return Object.assign({}, options, colOptions);
    };
    KtsDateTimeService.prototype.getFormatOptions = function (col, msg) {
        var format = msg['au.COMPONENT.KtsDateTimeComponent.option.format'];
        var formatDate = msg['au.COMPONENT.KtsDateTimeComponent.option.formatDate'];
        var formatTime = msg['au.COMPONENT.KtsDateTimeComponent.option.formatTime'];
        var colOptions = jsonpath.value(col, '$..options') || {};
        var options = new FormatOptions();
        options.format = colOptions.format || format || this.defFormat.format;
        options.formatDate = colOptions.formatDate || formatDate || this.defFormat.formatDate;
        options.formatTime = colOptions.formatTime || formatTime || this.defFormat.formatTime;
        return options;
    };
    KtsDateTimeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsDateTimeService.ctorParameters = function () { return []; };
    return KtsDateTimeService;
}());
export { KtsDateTimeService };
var FormatOptions = /** @class */ (function () {
    function FormatOptions() {
    }
    return FormatOptions;
}());
export { FormatOptions };
var PickerOptions = /** @class */ (function () {
    function PickerOptions() {
    }
    return PickerOptions;
}());
export { PickerOptions };
//# sourceMappingURL=datetime.service.js.map